module.exports = __webpack_public_path__ + "img/sv71.3d80598f.svg";